import React, { useState, useEffect } from 'react';

import { Card, CardHeader, CardContent, IconButton, ListItem, ListItemText } from '@mui/material';
import { Add, Delete, Edit } from '@mui/icons-material';
import { collection, onSnapshot, query } from 'firebase/firestore';

import LocationModal from './LocationModal';
import { db } from '../../../../firebase';

const locationCollection = collection(db, 'locations');

export default function LocationCard() {
  const [locations, setLocations] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [currentLocation, setCurrentLocation] = useState();

  const handleClose = () => {
    setOpenModal(false);
    setCurrentLocation(undefined);
  };

  const handleEdit = (location) => {
    setCurrentLocation(location);
    setOpenModal(true);
  }

  useEffect(() => {
    onSnapshot(query(locationCollection), (querySnapshot) => {
      const list = [];
      querySnapshot.forEach((doc) => {
        list.push({ ...doc.data(), id: doc.id });
      });
      setLocations(list);
    });
  }, []);

  return <>
    <Card>
      <CardHeader
        title="Locations"
        action={
          <IconButton aria-label="settings" onClick={() => setOpenModal(true)}>
            <Add />
          </IconButton>
        }
      />
      <CardContent>
        {locations.length > 0 ? <>
          {locations.map((location) => (
            <ListItem key={location.id} sx={{ paddingX: 0 }}>
              <ListItemText
                primary={location.name}
              />
              <IconButton onClick={() => handleEdit(location)}>
                <Edit />
              </IconButton>
              <IconButton onClick={() => console.log(location.id)}>
                <Delete />
              </IconButton>
            </ListItem>
          ))}
        </> : <p>No locations</p>}
      </CardContent>
    </Card>
    <LocationModal currentLocation={currentLocation} open={openModal} onClose={handleClose} />
  </>
}
